var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3271 0.945036C13.7257 0.714918 14.2354 0.851481 14.4655 1.25006L16.1494 4.16672H18.0002C18.9206 4.16672 19.6668 4.9129 19.6668 5.83339V17.5001C19.6668 18.4205 18.9206 19.1667 18.0002 19.1667H3.00016C2.0797 19.1667 1.3335 18.4206 1.3335 17.5001V5.83339C1.3335 4.9129 2.0797 4.16672 3.00016 4.16672H7.74697L13.3271 0.945036ZM14.2213 4.16053L13.4388 2.80508L11.0969 4.15714L14.2213 4.16053ZM18.0002 14.5834H15.1877C13.5581 14.5834 12.1668 13.3154 12.1668 11.6667C12.1668 10.0181 13.5581 8.75006 15.1877 8.75006H18.0002V5.83339H3.00016V17.5001H18.0002V14.5834ZM18.0002 10.4167H15.1877C14.401 10.4167 13.8335 11.0142 13.8335 11.6667C13.8335 12.3192 14.401 12.9167 15.1877 12.9167H18.0002V10.4167Z",
    fill: "url(#paint0_linear_1778_19573)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1778_19573",
    x1: 0.14183,
    y1: 9.99999,
    x2: 18.5147,
    y2: 19.5969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.8650b422ae568c328d8801404a38a93d.svg";
export { ForwardRef as ReactComponent };